import {FireInTheHole2} from "../../FireInTheHole2";
import {gsap} from "gsap";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FITH2Helper} from "../../utils/FITH2Helper";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {FITH2SoundManager} from "../../sound/FITH2SoundManager";

export class FreeSpinNoWinPause implements FlowStatePresentation {
    name: string = "FreeSpinNoWinPause";

    shouldRun(): boolean {
        return true;
    }

    start(controller: FlowStateController): void {
        const tl = gsap.timeline();
        let totalMultiplier: number = 0;
        FireInTheHole2.model.gameData.coinValues.forEach((values: number[]) => {
            totalMultiplier += FITH2Helper.sum(values);
        });
        if(totalMultiplier>FireInTheHole2.multiplier.currentMultiplierValue){
            tl.add([
                ()=>{FITH2SoundManager.playSound("fsMultiplierUp");},
                FireInTheHole2.initialWinView.addMultiValue()
            ],0);
        }
        if(NolimitConfig.isDevMode && totalMultiplier != FireInTheHole2.model.fsMultiplier){
            debugger
        }
        tl.add([
            FireInTheHole2.multiplier.update(FireInTheHole2.model.fsMultiplier)
        ], 0);
        //tl.add(()=>controller.finish(), `+=${FireInTheHole2.model.gameData.totalSpinWinnings?0.1:1}`);
        tl.add(()=>controller.finish(), `+=0.1`);
    }
}